/* eur-home-kc.js (redesign October 2026): homepage Knowledge Centre. Loaded with defer by
   sections/eur-home-kc-index.liquid only; safe for several instances and the theme editor.

   Content is complete without it: the newest guide is featured, the next ones are listed, every guide is a plain
   link and the Otto links fall back to /pages/ai. It adds:
   1. topic chips ([data-kx-tabs], role=tablist, rendered hidden and shown here): a chip features the newest guide of
      its topic ([data-kx-feat][data-kx-topic]; "All guides" = [data-kx-all]) and lists the rest of that topic in
      "More guides" ([data-kx-row], up to 5; from the 4th on they carry .is-x, which phones hide; the root's
      data-kx-max / data-kx-phone override the 5 / 3, e.g. 3 / 2 for the compact layout, 2026-10-10). Click, or
      ArrowLeft/ArrowRight/Home/End with the selection following focus (roving tabindex). The panel gets
      role=tabpanel + aria-labelledby the selected chip. Fires "kx:topic" on the section, detail {topic, label}.
   2. Otto ([data-kx-otto] = the guide title, or empty; [data-kx-src] = analytics source): opens the euronics-ai
      panel with "Tell me more about: <title>" prefilled (brief helper euOpenOtto); when the app is not there the
      link simply goes to its href. */
(function () {
  'use strict';
  if (window.__eurKc2) return;
  window.__eurKc2 = true;
  var d = document;
  var MAX = 5, PHONE = 3;
  var rm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function euOpenOtto(opts, el) {
    opts = opts || {};
    if (el) opts.opener = el;
    if (window.EuronicsAI && typeof window.EuronicsAI.open === 'function') { window.EuronicsAI.open(opts); return true; }
    var l = d.querySelector('.eai-launcher__open'); if (l) { l.click(); return true; }
    return false;
  }

  function init(root) {
    if (root.__kx) return;
    var off = [];
    function on(el, ev, fn, o) { el.addEventListener(ev, fn, o); off.push(function () { el.removeEventListener(ev, fn, o); }); }
    root.__kx = function () { off.forEach(function (f) { f(); }); off = []; root.__kx = null; };

    // ---------------------------------------------------------------- Otto
    on(root, 'click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-kx-otto]') : null;
      if (!a || !root.contains(a)) return;
      var t = a.getAttribute('data-kx-otto'), o = { source: a.getAttribute('data-kx-src') || 'home_kc' };
      if (t) o.prefill = 'Tell me more about: ' + t;
      try { if (euOpenOtto(o, a)) e.preventDefault(); } catch (err) { /* the link's href still works */ }
    });

    // ---------------------------------------------------------------- topic chips
    var tl = root.querySelector('[data-kx-tabs]');
    var panel = root.querySelector('[data-kx-panel]');
    if (!tl || !panel) return;
    var tabs = [].slice.call(tl.querySelectorAll('[role=tab]'));
    if (tabs.length < 2) return;
    // rows listed under the featured guide: data-kx-max (desktop) / data-kx-phone (phones), set by the section's layout
    var max = parseInt(root.getAttribute('data-kx-max'), 10) || MAX;
    var phone = parseInt(root.getAttribute('data-kx-phone'), 10) || PHONE;
    var feats = [].slice.call(panel.querySelectorAll('[data-kx-feat]'));
    var rows = [].slice.call(panel.querySelectorAll('[data-kx-row]'));
    var empty = panel.querySelector('[data-kx-empty]');
    var cur = 0, swt;

    function apply(topic) {
      var all = !topic || topic === 'all', lead = null;
      feats.forEach(function (f) {
        if (!lead && (all ? f.hasAttribute('data-kx-all') : f.getAttribute('data-kx-topic') === topic)) lead = f;
      });
      if (!lead) lead = feats[0];
      feats.forEach(function (f) { f.hidden = f !== lead; });
      var li = lead ? lead.getAttribute('data-kx-i') : null, n = 0;
      rows.forEach(function (r) {
        var ok = n < max && r.getAttribute('data-kx-i') !== li && (all || r.getAttribute('data-kx-topic') === topic);
        r.hidden = !ok;
        r.classList.toggle('is-x', ok && n >= phone);
        if (ok) { r.style.setProperty('--kx-o', n); n++; }
      });
      if (empty) empty.hidden = n > 0;
    }

    function select(i, focus) {
      if (i < 0 || i >= tabs.length) return;
      var changed = i !== cur;
      cur = i;
      tabs.forEach(function (t, j) {
        t.setAttribute('aria-selected', j === i ? 'true' : 'false');
        t.tabIndex = j === i ? 0 : -1;
      });
      panel.setAttribute('aria-labelledby', tabs[i].id);
      if (focus) {
        tabs[i].focus();
        if (tl.scrollWidth > tl.clientWidth && tabs[i].scrollIntoView) {
          tabs[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: rm && rm.matches ? 'auto' : 'smooth' });
        }
      }
      if (!changed) return;
      apply(tabs[i].getAttribute('data-kx-topic'));
      if (!(rm && rm.matches)) {                    // a short fade-in of the swapped cards (CSS .is-sw)
        clearTimeout(swt);
        panel.classList.remove('is-sw'); void panel.offsetWidth; panel.classList.add('is-sw');
        swt = setTimeout(function () { panel.classList.remove('is-sw'); }, 800);
      }
      try {
        root.dispatchEvent(new CustomEvent('kx:topic', { bubbles: true, detail: { topic: tabs[i].getAttribute('data-kx-topic'), label: tabs[i].textContent.trim() } }));
      } catch (err) { /* old browsers: no event */ }
    }

    tabs.forEach(function (t, i) {
      on(t, 'click', function () { select(i, false); });
    });
    on(tl, 'keydown', function (e) {
      var i = tabs.indexOf(d.activeElement), n = -1;
      if (i < 0) return;
      switch (e.key) {
        case 'ArrowRight': n = (i + 1) % tabs.length; break;
        case 'ArrowLeft': n = (i - 1 + tabs.length) % tabs.length; break;
        case 'Home': n = 0; break;
        case 'End': n = tabs.length - 1; break;
        default: return;
      }
      e.preventDefault();
      select(n, true);
    });

    // the chips are rendered hidden (nothing inert without the script); show them and wire the panel
    panel.setAttribute('role', 'tabpanel');
    panel.setAttribute('aria-labelledby', tabs[0].id);
    tabs.forEach(function (t, j) { t.tabIndex = j === 0 ? 0 : -1; });
    tl.hidden = false;
    off.push(function () { clearTimeout(swt); panel.classList.remove('is-sw'); });
  }

  function boot(ctx) { [].forEach.call((ctx || d).querySelectorAll('[data-kx]'), init); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  // theme editor: a re-rendered section gets a fresh root; the old one is torn down first
  d.addEventListener('shopify:section:unload', function (e) {
    [].forEach.call(e.target.querySelectorAll('[data-kx]'), function (r) { if (r.__kx) r.__kx(); });
  });
  d.addEventListener('shopify:section:load', function (e) { boot(e.target); });
}());
